import {
  IconUser,
  IconPlayerPlay,
  IconTextPlus,
  IconBrain,
  IconActivity,
} from "@tabler/icons-react";
import AdminUsersList from "../features/admin-users-list/AdminUsersList";
import AdminPlaybooks from "../features/admin-playbooks/AdminPlaybooks";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import SettingsModal from "../features/header/components/Settings";
import { useNavigate } from "react-router-dom";
import AdminExternalAgents from "@/features/admin-external-agents/AdminExternalAgents";
import AdminLLMManagement from "@/features/admin-llm-management/AdminLLMManagement";
import AdminLLMStatus from "@/features/admin-llm-status/AdminLLMStatus";

export default function AdminDashboard() {
  const [settingsOpened, setSettingsOpened] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <div className="bg-white border-b border-gray-100">
        <div className="container mx-auto max-w-7xl px-8 py-6">
          <div className="flex justify-between items-center">
            <div>
              <div className="flex items-center gap-3 mb-1">
                <Button
                  variant="ghost"
                  size="sm"
                  className="text-gray-600 gap-1.5 text-sm h-8"
                  onClick={() => navigate("/")}
                >
                  <ArrowLeft className="h-4 w-4" />
                  Back to Home
                </Button>
              </div>
              <h1 className="text-2xl font-bold text-gray-900">
                Admin Dashboard
              </h1>
              <p className="text-gray-500 text-base">
                Manage users, chats, and system settings
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto max-w-7xl px-8 py-6">
        <Tabs defaultValue="users" className="w-full">
          <TabsList className="flex h-10 items-center justify-start gap-1">
            <TabsTrigger value="users" className="flex items-center gap-2">
              <IconUser className="h-4 w-4" />
              Users
            </TabsTrigger>
            <TabsTrigger value="playbooks" className="flex items-center gap-2">
              <IconPlayerPlay className="h-4 w-4" />
              Playbooks
            </TabsTrigger>
            <TabsTrigger
              value="external-agents"
              className="flex items-center gap-2"
            >
              <IconTextPlus className="h-4 w-4" />
              External Agents
            </TabsTrigger>
            <TabsTrigger
              value="llm-management"
              className="flex items-center gap-2"
            >
              <IconBrain className="h-4 w-4" />
              LLM Management
            </TabsTrigger>
            <TabsTrigger value="llm-status" className="flex items-center gap-2">
              <IconActivity className="h-4 w-4" />
              LLM Status
            </TabsTrigger>
          </TabsList>

          <TabsContent value="users" className="mt-4">
            <AdminUsersList />
          </TabsContent>
          <TabsContent value="playbooks" className="mt-4">
            <AdminPlaybooks />
          </TabsContent>
          <TabsContent value="external-agents" className="mt-4">
            <AdminExternalAgents />
          </TabsContent>
          <TabsContent value="llm-management" className="mt-4">
            <AdminLLMManagement />
          </TabsContent>
          <TabsContent value="llm-status" className="mt-4">
            <AdminLLMStatus />
          </TabsContent>
        </Tabs>
      </div>

      <SettingsModal
        opened={settingsOpened}
        close={() => setSettingsOpened(false)}
      />
    </div>
  );
}
